module.exports = __webpack_public_path__ + "img/gou-lite.24a96906.png";